import NextImage from 'next/image';

import { Heading } from '../../../../../components/Heading/Heading';
import { Text } from '../../../../../components/Text/Text';
import CTABackgroundMobile from '../assets/TopBaitsCTABackground-mobile.png';
import CTABackgroundTablet from '../assets/TopBaitsCTABackground-tablet.png';
import CTABackgroundDesktop from '../assets/TopBaitsCTABackground.png';
import { Source } from '../../../../../components/NextImage/Source';
import { AppStoreButtons } from '../../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { QRCode } from '../../../../../components/QRCode/QRCode';
interface IProps {
  speciesId: string;
}

export const TopBaitsSectionCTA = ({ speciesId }: IProps) => {
  return (
    <div className="relative -mb-6 flex flex-col">
      <div className="pointer-none: absolute top-3/5 z-10 size-full bg-[linear-gradient(180deg,_#FFF_37.98%,_rgba(255,255,255,0)_100%)] sm:bg-[linear-gradient(180deg,_#F5F6F7_37.98%,_rgba(245,246,247,0)_100%)]"></div>
      <div className="z-mid mx-auto flex flex-col items-center justify-center gap-4 pt-7 pb-4 text-center">
        <div className="relative rounded-xl p-6 sm:p-8">
          <picture>
            <Source media="(min-width: 990px)" src={CTABackgroundDesktop}></Source>
            <Source media="(min-width: 600px)" src={CTABackgroundTablet}></Source>
            <NextImage
              data-testid="appBannerLogo"
              alt="Fishbrain"
              src={CTABackgroundMobile}
              fill
              className="rounded-xl"
            />
          </picture>
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="flex flex-row items-center sm:max-w-[50%] md:max-w-none md:gap-x-10">
              <div className="md:max-w-auto z-mid text-sea-foam flex flex-col gap-2 text-center sm:text-left">
                <Heading as="div" className="text-sea-foam" variant="xs">
                  Stop guessing and start catching
                </Heading>
                <Text className="m-0" variant="sm">
                  Find out what lures to use, download the Fishbrain app!
                </Text>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-4">
              <AppStoreButtons
                className="z-mid md:hidden"
                orientation="vertical"
                source="TopSpeciesCTA"
                sourceId={speciesId}
              />
            </div>

            <div className="z-mid relative ml-4 hidden items-center justify-center sm:justify-start md:flex">
              <QRCode className="bg-sea-foam rounded-md p-2 md:ml-4" source="TopSpeciesCTA" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
